module.exports = __webpack_public_path__ + "static/img/43036.55bea97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/43036.jpg
// module id = Kb2t
// module chunks = 1